import React from 'react';

export default class Pipe extends React.Component {

  render() {
    const additionalClassName = (this.props.additionalClassName) ? this.props.additionalClassName : '';
    const scrollProgressType = this.props.scrollProgressType ? this.props.scrollProgressType : null

    return (
      <div className={`row Pipe ${additionalClassName}`}>
        <div className="col-xs-16">
          <div className="pipe" data-scroll-item-progress={scrollProgressType}></div>
        </div>
      </div>
    );
  }

};
